
export const configuration = {
  environment: process.env.REACT_APP_NODE_ENV || "",
  mentaport: {
    adminCustomerType: process.env.REACT_APP_ADMIN_CUSTOMER_TYPE || "",
  },
  certificateAppUserRegistry: {
    baseUrl:process.env.REACT_APP_CERT_BASE_URL || "",
  },
  dashboardUserRegistry: {
    baseUrl:process.env.REACT_APP_ADMIN_BASE_URL || "",
    authDomain: process.env.REACT_APP_AUTH0_ADMIN_DOMAIN || "",
    audience: process.env.REACT_APP_AUTH0_ADMIN_AUDIENCE || "",
    clientId: process.env.REACT_APP_AUTH0_ADMIN_CLIENT_ID || "",
  },
  june: {
    writeKey: process.env.REACT_APP_JUNE_KEY || "",
    groupId: process.env.REACT_APP_NODE_ENV || "",
  },
  api: {
    apiUrl: process.env.REACT_APP_API_BACKEND_URL || "",
  },
};
